import React, { useState } from "react";
import { upIndicator, downIndicator } from "../../assetData/icons";

const DashboardBlockD = ({ topGainerLossers }) => {
  const [selectedOption, setSelectedOption] = useState("gainers");
  const [hoveredScriptName, setHoveredScriptName] = useState(null);

  let dataToDisplay = [];

  switch (selectedOption) {
    case "gainers":
      dataToDisplay = topGainerLossers?.gainer?.slice(0, 5);
      break;
    case "losers":
      dataToDisplay = topGainerLossers?.looser?.slice(0, 5);
      break;
    case "marketValue":
      dataToDisplay = topGainerLossers?.market_value?.slice(0, 5);
      break;
    default:
      break;
  }

  return (
    <div
      className={
        selectedOption === "marketValue"
          ? "flex h-[90%] flex-col justify-between "
          : "flex h-full flex-col justify-between "
      }
    >
      <div className="flex justify-between">
        <div className="text-sm font-bold text-neutral-800">Top 5</div>
        <div>
          <select
            value={selectedOption}
            onChange={(e) => setSelectedOption(e.target.value)}
            className="bg-white text-sm font-medium text-neutral-800 outline-none"
          >
            <option value="gainers">Gainers</option>
            <option value="losers">Losers</option>
            <option value="marketValue">Market Value</option>
          </select>
        </div>
      </div>

      <div
        className={
          " overflow-x-scroll scrollbar-custom md:space-x-6 mt-0 flex w-full justify-start gap-2 max-md:flex max-md:flex-wrap"
        }
      >
        {dataToDisplay &&
          dataToDisplay?.map((data, idx) => (
            <div key={idx} className="max-md:w-full">
              <div className="flex w-full gap-4 rounded-lg border-gray-500 p-2 max-md:mt-4 max-md:w-full max-md:justify-between md:flex-col">
                <div className="space-y-2  ">
                  <div
                    onMouseOver={() =>
                      setHoveredScriptName(
                        data?.script_code.length > 15 && data?.script_code,
                      )
                    }
                    onMouseLeave={() => setHoveredScriptName(null)}
                    className="whitespace-nowrap text-neutral-700 max-md:hidden md:w-[140px]"
                  >
                    {data?.script_code.length > 15
                      ? data?.script_code.slice(0, 15) + "..."
                      : data?.script_code}
                  </div>
                  <div
                    onMouseOver={() =>
                      setHoveredScriptName(
                        data?.script_code.length > 40 && data?.script_code,
                      )
                    }
                    onMouseLeave={() => setHoveredScriptName(null)}
                    className="whitespace-nowrap text-neutral-700 max-sm:hidden  md:hidden md:w-[140px]"
                  >
                    {data?.script_code.length > 40
                      ? data?.script_code.slice(0, 40) + "..."
                      : data?.script_code}
                  </div>
                  <div
                    onMouseOver={() =>
                      setHoveredScriptName(
                        data?.script_code.length > 40 && data?.script_code,
                      )
                    }
                    onMouseLeave={() => setHoveredScriptName(null)}
                    className="whitespace-nowrap text-neutral-700  sm:hidden md:w-[140px]"
                  >
                    {data?.script_code.length > 15
                      ? data?.script_code.slice(0, 15) + "..."
                      : data?.script_code}
                  </div>
                  {hoveredScriptName === data?.script_code && (
                    <div className="absolute w-fit whitespace-nowrap rounded-[5px] bg-[#D9D9D9] p-[5px] text-neutral-700">
                      {data?.script_code}
                    </div>
                  )}
                  <div className="font-semibold text-neutral-800">
                    {data?.cmp ? data?.cmp?.toFixed(2) : null}
                  </div>
                  <div>
                    {data?.qty?.toFixed(0)}{" "}
                    <span className="text-neutral-400">Share</span>{" "}
                  </div>
                </div>
                {selectedOption === "marketValue" ? (
                  <div className="grid grid-cols-2 grid-rows-3 ">
                    <div className="row-start-1 text-neutral-400 max-md:col-start-2 md:col-start-1">
                      Market Value{" "}
                    </div>
                    <div className="row-start-1.5 max-md:col-start-2 md:col-start-1">
                      {data?.new_price.toFixed(2)}{" "}
                    </div>
                  </div>
                ) : (
                  <div className="grid grid-cols-2">
                    <div className="col-start-1 text-neutral-400">
                      <div>Gain/Loss</div>
                      <div>Percentage</div>
                    </div>
                    <div className="col-start-1 flex gap-2">
                      <img
                        src={data?.percentage > 0 ? upIndicator : downIndicator}
                        alt=""
                      />
                      <div className="w-[60px] text-right">
                        {data?.percentage.toFixed(2)}%
                      </div>
                    </div>

                    <div className="col-start-2 row-start-1 ml-[35px] text-neutral-400">
                      Market
                      <br />
                      Value
                    </div>
                    <div className="col-start-2 row-start-2 ml-[35px]">
                      <div className="w-[60px] text-right">
                        {data?.new_price.toFixed(2)}
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          ))}
      </div>
    </div>
  );
};

export default DashboardBlockD;
